import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import PostAddIcon from "@mui/icons-material/PostAdd";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { Link } from "react-router-dom";

const EmptyTableData = ({ colSpan, btnTitle, path }) => {
  return (
    <>
      <TableRow>
        <TableCell align="center" colSpan={colSpan}>
          <Box sx={{ textAlign: "center", width: "100%", py: 10 }}>
            <PostAddIcon color="primary" sx={{ fontSize: "150px" }} />
            <h2>No Data Available</h2>
            <Box sx={{ mt: 3 }}>
              <Link to={path}>
                <Button variant="contained" size="large">
                  {btnTitle}
                </Button>
              </Link>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};

export default EmptyTableData;
